import { CommonModule } from '@angular/common';
import {
    Component,
    Input,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { CountdownRingComponent } from '../../../../../../shared/components/countdown-ring/countdown-ring.component';
import { GoSearchInformationService } from '../../services/go-search-information-form/go-search-information.service';
import { Observable, tap } from 'rxjs';
import {
    htmlDatetimeAttributeDateFormat,
    htmlDateTimeAttributeTimeFormat,
} from '../../../../../../core/constants/date-pipe';
import {
    formatToDate,
    parseDateToEasternDateOnly,
    parseDateToEasternTimeOnly,
} from '../../../../../../core/functions/date-helpers';

@Component({
    selector: 'app-go-search-information',
    imports: [MatExpansionModule, CommonModule, CountdownRingComponent],
    templateUrl: './go-search-information.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['../../../shared/styles/go-mat-panel.scss'],
})
export class GoSearchInformationComponent implements OnInit {
    @Input() expanded: boolean = true;
    @Input() hideToggle: boolean = false;
    @Input() disabled: boolean = false;

    expansionPanelDescription: string = '';
    htmlDatetimeAttributeDateFormat: string = htmlDatetimeAttributeDateFormat;
    htmlDateTimeAttributeTimeFormat: string = htmlDateTimeAttributeTimeFormat;

    constructor(
        private readonly goSearchInformationService: GoSearchInformationService,
    ) {}

    get totalMs(): number {
        return this.goSearchInformationService.totalMs;
    }

    get completedAt(): Date | null {
        const status =
            this.goSearchInformationService.getApplicationCoordinationStatus();

        if (!status || !status.coordinationCompletedAt) {
            return null;
        }

        return formatToDate(status.coordinationCompletedAt);
    }

    get reservedUntil(): Date | null {
        const status =
            this.goSearchInformationService.getApplicationCoordinationStatus();

        if (!status || !status.coordinationResultsExpireAt) {
            return null;
        }
        return formatToDate(status.coordinationResultsExpireAt);
    }

    get remainingMsObservable(): Observable<number> {
        return this.goSearchInformationService.remainingMs$;
    }

    get percentRemainingObservable(): Observable<number> {
        return this.goSearchInformationService.percentRemaining$;
    }

    ngOnInit(): void {
        this.updateExpansionPanelDescriptionHandler();
    }

    getExpansionPanelDescription(ms: number): string {
        return `${this.goSearchInformationService.getFormattedTimeRemaining(ms)} remaining`;
    }

    getFormattedTime(date: Date | string | null): string {
        if (!date) {
            return '';
        }

        return parseDateToEasternTimeOnly(date);
    }

    getFormattedDate(date: Date | string | null): string {
        if (!date) {
            return '';
        }

        return parseDateToEasternDateOnly(date);
    }

    getFormattedTimeRemaining(ms: number): string {
        return this.goSearchInformationService.getFormattedTimeRemaining(ms);
    }

    private updateExpansionPanelDescriptionHandler(): void {
        this.remainingMsObservable
            .pipe(
                tap((ms) => {
                    this.expansionPanelDescription =
                        this.getExpansionPanelDescription(ms);
                }),
            )
            .subscribe();
    }
}
